document.addEventListener('DOMContentLoaded', function () {
  let tabs = document.querySelectorAll('.size-variables span');
  let content = document.querySelectorAll('.content-tab');
  tabs.forEach((element) => {
    element.addEventListener('click', function (event) {
      tabs.forEach((element) => {
          element.classList.remove('active');
        });
      content.forEach((element) => {
          element.classList.remove('active');
        });
      this.classList.add('active');
      let ID = this.getAttribute('data-id');
      document.querySelector(`.content-tab[data-id="${ID}"]`).classList.add('active');
    });
  });  
  class MeasurementsTable extends HTMLElement {
    static ATTRIBUTE_LABELS = {
      '*Armholedepth': '*Arm hole depth',
      '*Armholestretched': '*Arm hole stretched',
      '*Backarmholeincurve': '*Back arm hole in curve',
      '*Backnecklength': '*Back neck length',
      '*Biceps': '*Biceps',
      '*Bodyknittingdensity:Coursesper10cm': '*Body knitting density: courses per 10cm',
      '*Bodyknittingdensity:Walesper10cm': '*Body knitting density: wales per 10cm',
      '*Bodylength': '*Body length',
      '*Centerbacklength': '*Center back length',
      '*Centerfrontlength': '*Center front length',
      '*Chestdartlength': '*Chest dart length',
      '*Chest': '*Chest',
      '*Crossback': '*Cross back',
      '*Crossfront': '*Cross front',
      '*DownfromHSPtothechestpocket': '*Down from HSP to the chest pocket',
      '*Frontarmholeincurve': '*Front arm hole in curve',
      '*Frontlength': '*Front length',
      '*Frontneckdrop': '*Front neck drop',
      '*Frontnecklength': '*Front neck length',
      '*Hem': '*Hem',
      '*Neckholestretched': '*Neck hole stretched',
      '*Neckopening': '*Neck opening',
      '*Rib/Bindingdepth': '*Rib/Binding depth',
      '*Seescheme': '*See scheme',
      '*Seescheme/参见方案': '*See scheme/参见方案',
      '*Shoulders': '*Shoulders',
      '*Shoulderseamstretched': '*Shoulder seam stretched',
      '*Sideseamlength': '*Side seam length',
      '*Singleshoulder': '*Single shoulder',
      '*Sleevebottom': '*Sleeve bottom',
      '*Sleevecuffdepth': '*Sleeve cuff depth',
      '*Sleeveinnerseamlength': '*Sleeve inner seam length',
      '*Sleevelength': '*Sleeve length',
      '*Sideziplength': '*Side zip length',
      '*Waistlength': '*Waist length',
      '*Chestdartlength': '*Chest dart length',
      '*Sideslitlength': '*Side slit length',
      '*Straplength': '*Strap length',
      '*Strapwidth': '*Strap width',
      '*Backzip\fasteningopening': '*Backzip\fastening opening',
      '*Waistlevel': '*Waist level',
      'Beltendlength': 'Belt end length',
      'Beltlength': 'Belt length',
      'Backneckdrop': 'Back neck drop',
      'Chestpocketlength': 'Chest pocket length',
      'Chestpocketwidth': 'Chest pocket width',
      'Crossfrontlevel': 'Cross front level',
      'Centerbacktoplength': 'Center back top length',
      '*Collarstanddepth': '*Collar stand depth',
      '*Collarlength': '*Collar length',
      '*Collarwidth': '*Collar width',
      '*Collardepth': '*Collar depth',
      '*Elbowlevel': '*Elbow level',
      '*Lapelpoint': '*Lapel point',
      'Shoulderpadlength': 'Shoulder pad length',
      'Shoulderpadwidth': 'Shoulder pad width',
      'Waistpocketflapdepthatcentre': 'Waist pocket flap depth at centre',
      'Waistpocketlength': 'Waist pocket length',
      'Wentlength': 'Went length',
      'Sleeveplacketlength': 'Sleeve placket length',
      'DistancefromHSPtofirstbutton': 'Distance from HSP to first button',
      'Distancefromthefrontedgetothewaistpocket': 'Distance from the front edge to the waist pocket',
      '*Panelarmholeincurve': '*Panel arm hole in curve',
      '*Neckcircumference': '*Neck circumference',
      '*DownfromHSPtothewaistpocket': '*Down from HSP to the waist pocket',
      'Positionofthechesttuckalongthesideseam': 'Position of the chest tuck along the side seam',
      'Distancetotheedgeofdart': 'Distance to the edge of dart',
      'PositionCrossback': 'Position cross back',
      'Frontlininglength': 'Front lining length',
      '*Backlength(skirt)': '*Back length (skirt)',
      '*Backziplength': '*Back zip length',
      '*Frontlength(skirt)': 'Front length (skirt)',
      'Frontziplength': 'Front zip length',
      'Distancetobeltloop(seescheme)': 'Distance to belt loop (see scheme)',
      'Distancebetweenbuttons': 'Distance between buttons',
      'SleevelengthfromCenterBack(full)': 'Sleeve length from center back (full)',
      'Distancefromchestpatchpockettocenterfront': 'Distance from chest patch pocket to center front',
      'Distancefromthecenterofthebacktotheprint': 'Distance from the center of the back to the print',
      'Distancefromthetopofthepockettotheprint': 'Distance from the top of the pocket to the print',
      'Distancefrombottomtocarelabelalongsideseam': 'Distance from bottom to care label along side seam',
      'Garmentfrontlengthonadummyorperson': 'Garment front length on a dummy or person',
      'Garmentsleevelengthonadummyorperson': 'Garment sleeve length on a dummy or person',
      'Hangerlooplength(1/2length)': 'Hanger loop length (1/2 length)'
    };

    connectedCallback() {
      this.dataScript = this.querySelector('script[type="application/json"]');

      if (!this.dataScript) return;

      this.data = JSON.parse(this.dataScript.textContent);
      this.container = document.createElement('div');
      this.classList.add('measurements-table');
      this.renderTable();
      this.appendChild(this.container);
    }
  
    renderTable() {
      const table = document.createElement('table');
      const thead = document.createElement('thead');
      const tbody = document.createElement('tbody');
  
      // Create header row
      const headerRow = document.createElement('tr');
      const emptyHeader = document.createElement('th');
      headerRow.appendChild(emptyHeader);
  
      this.data.sizes.forEach(size => {
        const th = document.createElement('th');
        th.innerText = size;
        headerRow.appendChild(th);
      });
  
      thead.appendChild(headerRow);
      table.appendChild(thead);
  
      // Create data rows
      this.data.measurements.forEach(measurement => {
        const row = document.createElement('tr');
        const attributeCell = document.createElement('td');
        const attr = measurement.attribute;
        attributeCell.innerText = MeasurementsTable.ATTRIBUTE_LABELS[attr] ?? attr;
        row.appendChild(attributeCell);
  
        this.data.sizes.forEach(size => {
          const cell = document.createElement('td');
          cell.innerText = measurement[size];
          row.appendChild(cell);
        });
  
        tbody.appendChild(row);
      });
  
      table.appendChild(tbody);
      this.container.appendChild(table);
    }
  }

  customElements.define('measurements-table', MeasurementsTable);
});